import type { TypographyVariantsOptions } from '@mui/material/styles';

export const typography: TypographyVariantsOptions = {
  body1: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: 1.5,
  },
  body2: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 1.5,
    letterSpacing: '0.17px',
  },
  overline: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 1.5,
    letterSpacing: '1px',
  },
  caption: {
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: 1.5,
    letterSpacing: '0.4px',
  },
};
